import { Navigate, useRoutes } from 'react-router-dom';

// routes
// import RedirectRoutes from './rediretRoutes';
import AdminRoutes from './AdminRoutes';
import EmployeeRoutes from './EmployeeRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import PublicRoutes from './PublicRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([PublicRoutes, EmployeeRoutes, AuthenticationRoutes, AdminRoutes]);
}
